<template>
  <div class="cookie-bar shadow fixed c-w-100 left-0 bottom-0">
    <div class="bar-container text-center block c-mx-auto">
      <div class="bar-title font-bold c-lg:c-mb-3 c-mb-2 align-middle">
        <i class="mi-cookies icon-32 c-mr-1 mi-lh-1" />
        Cookies
      </div>
      <p>
        <span
          class="c-px-1"
          v-html="t('cookie_use_agreement')"
        />
        <router-link :to="{ name: 'cookiesPath' }">
          {{ t('more_information') }}
        </router-link>
      </p>
      <button
        type="button"
        class="btn btn-success c-py-3 c-px-6 c-rounded-pill c-mr-3"
        @click="setAllCookieConsentSettings"
      >
        {{ t('ok') }}
      </button>
      <button
        type="button"
        class="btn btn-outline-primary c-py-3 c-px-4 c-mr-1 c-rounded-pill"
        @click="openModal({ id: 'modal-cookies' })"
      >
        {{ t('settings') }}
      </button>
      <button
        type="button"
        class="btn c-py-3 c-px-4 c-rounded-pill underline"
        data-cy="cookie-bar-close-button"
        @click="setNoneCookieConsentSettings"
      >
        {{ t('close') }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

import ApiServiceV1 from '@/api/adminApi/AdminApiV1'
import { useAppStore } from '@/stores/AppStore'
import { useModalStore } from '@/stores/ModalStore'

const { openModal } = useModalStore()
const { setCookieConsentSettings } = useAppStore()
const { t } = useI18n()

const setAllCookieConsentSettings = async () => {
  setCookieConsentSettings(['analytic', 'personal', 'advertisement'])
  await ApiServiceV1.post('cookie_consent_stats', {
    advertisment_agreed: true,
    personalized_agreed: true,
    analytics_agreed: true,
  })
}
const setNoneCookieConsentSettings = async () => {
  setCookieConsentSettings([])
  await ApiServiceV1.post('cookie_consent_stats', {
    advertisment_agreed: false,
    personalized_agreed: false,
    analytics_agreed: false,
  })
}
</script>

<style lang="scss">
.cookie-bar {
    background-color: $primary-color-200;
    padding: 24px 0;
    z-index: 10350;
    border-top: 1px solid #4f2b1b;
    
    .bar-container {
        max-width: 800px;
        width: 95%;

        .bar-title {
            font-size: 22px;
        }
    }

    @media screen and (max-width: 991px) {
        .bar-container {
            p {font-size: 14px;}
        }
    }
}
</style>

<i18n>
  {
    "cs": {
    "close": "Odmítnout",
    "cookie_use_agreement": "Mixit potřebuje váš souhlas s použitím souborů cookies, aby se vám mohli zobrazovat informace v souladu s vašimi zájmy.",
    "more_information": "Další informace",
    "ok": "Souhlasím",
    "settings": "Nastavení"
},
    "sk": {
    "close": "Zavrieť",
    "cookie_use_agreement": "Mixit potrebuje Váš súhlas s použitím súborov cookies, aby sa Vám mohli zobrazovať informácie v súlade s Vašimi záujmami.",
    "more_information": "Ďalšie informácie",
    "ok": "OK",
    "settings": "Nastavenia"
},
    "pl": {
    "close": "Zrezygnuj",
    "cookie_use_agreement": "Mixit potrzebuje Twojej zgody na korzystanie z plików cookies, aby móc wyświetlać informacje zgodnie z Twoimi zainteresowaniami.",
    "more_information": "Więcej informacji",
    "ok": "Ok",
    "settings": "Ustawienia"
},
    "hu": {
    "close": "Visszautasítani",
    "cookie_use_agreement": "A Mixitnek szüksége van a hozzájárulásodra ahhoz, hogy a sütiket a te érdeklődési körödnek megfelelő információk megjelenítéséhez használhassa.",
    "more_information": "További információ",
    "ok": "OK",
    "settings": "Beállítások"
},
    "de": {
    "close": "Ablehnen",
    "cookie_use_agreement": "Mixit benötigt deine Zustimmung zur Verwendung von Cookies, um Dir Informationen zu zeigen, die deinen Interessen entsprechen.",
    "more_information": "Weitere Informationen",
    "ok": "Ok",
    "settings": "Einstellungen"
},
    "at": {
    "close": "Ablehnen",
    "cookie_use_agreement": "Mixit benötigt deine Zustimmung zur Verwendung von Cookies, um Dir Informationen zu zeigen, die deinen Interessen entsprechen.",
    "more_information": "Weitere Informationen",
    "ok": "Ok",
    "settings": "Einstellungen"
},
    "ro": {
    "close": "Refuzați",
    "cookie_use_agreement": "Mixit are nevoie de consimțământul dvs. pentru utilizarea cookie-urilor, astfel încât acestea să vă poată afișa informații în conformitate cu interesele dvs.",
    "more_information": "Mai multe informații",
    "ok": "OK",
    "settings": "Setări"
},
    "fr": {
    "close": "Refuser",
    "cookie_use_agreement": "Mixit a besoin de votre consentement pour l’utilisation des cookies afin de vous afficher des informations adaptées à vos centres d’intérêt.",
    "more_information": "Plus d'informations",
    "ok": "Je suis d'accord",
    "settings": "Paramètres"
},
    "it": {
    "close": "Rifiuta",
    "cookie_use_agreement": "Mixit ha bisogno del tuo consenso per utilizzare i cookie per poterti mostrare contenuti in linea con i tuoi interessi.",
    "more_information": "Maggiori informazioni",
    "ok": "Accetto",
    "settings": "Impostazioni"
}
  }
</i18n>
